// ThemeConstants.js
// export const isBidnaaTheme = () => document.body.className == 'MultiSeller_two bidNaa'
// export const isHawaiiTheme = () => document.body.classList[1] == 'hawaii'
// export const isBargainsTheme = () => global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
// // eslint-disable-next-line prettier/prettier
// export const isBuyBestProject = () => global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
// export const isBid2Shop = () => global.storeConfigration?.bodyClass?.value === 'bidShop'

import { get } from 'lodash'

export const ThemeConstant = {
    get isBidnaaTheme() {
        return document.body.className === 'MultiSeller_two bidNaa'
    },
    get isHawaiiTheme() {
        return document.body.classList[1] === 'hawaii'
    },
    get isBargainsTheme() {
        return global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    },
    get isBuyBestProject() {
        return global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    },
    get isBid2Shop() {
        return global.storeConfigration?.bodyClass?.value === 'bidShop'
    },
    get isWizardTheme() {
        return get(document, 'body.classList[1]') === 'wizardTheme'
    },
    get isRetailRushTheme() {
        return global.storeConfigration?.bodyClass?.value === 'greenField'
    },
    get isPrimeBidsTheme() {
        return global.storeConfigration?.bodyClass?.value == 'primeBids'
    },
}
